import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/services/auth/auth.service';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'settings-for-account',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDividerModule,
    MatListModule,
    MatIconModule,
  ],
  templateUrl: './settings-for-account.component.html',
  styleUrl: './settings-for-account.component.scss',
})
export class SettingsForAccountComponent {
  @Output()
  onOpenLoginRequested: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public authService: AuthService,
    private _matSnackBar: MatSnackBar
  ) {}

  login() {
    this.onOpenLoginRequested.emit();
  }

  logout() {
    if (confirm('Are you sure you want to log out?')) {
      this.authService.logout();
    }
  }

  async changeEmail() {
    const newEmail = prompt('New email address');
    if (newEmail) {
      try {
        await this.authService.changeEmailAndLogOut(newEmail);
      } catch (e: any) {
        this._matSnackBar.open('Unexpected error' + e.toString());
      }
    }
  }

  async resetPassword() {
    const confirmed = confirm(
      'Are you sure you want to reset your password and log out?'
    );
    if (confirmed) {
      try {
        await this.authService.sendPasswordResetEmail();
        await this.authService.logout();
      } catch (e: any) {
        this._matSnackBar.open('Unexpected error' + e.toString());
      }
    }
  }

  async resendEmailVerification() {
    if (!this.authService.user?.emailVerified) {
      await this.authService.user?.sendEmailVerification();
      this._matSnackBar.open('Verification email sent');
    } else {
      this._matSnackBar.open('Your email is already verified');
    }
  }

  async deleteAccount() {
    const confirmed = confirm(
      'Are you sure you want to delete your account? All your data will be irreversibly deleted. This action cannot be undone.'
    );
    if (confirmed) {
      try {
        const deleteWithCaps = prompt(
          'Plese type in the word DELETE, with all caps. This is to confirm that you want to delete your account. After you hit OK, your account will be deleted.'
        );
        if (deleteWithCaps === 'DELETE') {
          try {
            await this.authService.deleteAccount();
          } catch (e: any) {
            console.log(e.message);
            this._matSnackBar.open(e.message);
          }
        } else {
          alert('Incorrect input. Account not deleted.');
        }
      } catch (e: any) {
        this._matSnackBar.open('Unexpected error' + e.toString());
      }
    }
  }
}
